export default function checkWinner(squares) {
    const ways = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [0, 3, 6],
        [1, 4, 7],
        [2, 5, 8],
        [0, 4, 8],
        [2, 4, 6]
    ]



    for (let i = 0; i < ways.length; i++) {
        const [a, b, c] = ways[i];
        if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
            return `Winner: ${squares[a]}`
        }
    }


    let flag = false;
    for (let i = 0; i < squares.length; i++) {
        if (squares[i] == null) {
            flag = true
        }
    }
    if (flag === false) {
        return "Its a Draw!"
    }

    return null;
}